import { Component, Input } from '@angular/core';
import { MediaPlayerService } from '@core/service/media-player/media-player.service';
import { ImportALlModule } from '@shared/imports';

@Component({
  selector: 'app-media-player-button',
  standalone: true,
  imports: [
    ImportALlModule,
  ],
  templateUrl: './media-player-button.component.html',
  styleUrl: './media-player-button.component.scss'
})
export class MediaPlayerButtonComponent {

  @Input() playOnClick: boolean = true;
  @Input() showMatMenu: boolean = false; // Pour afficher le sous menu deroulante
  @Input() showChildPlay: boolean = false; // Pour afficher le bouton play, Pause dasn la page mere
  @Input() label: string = '';
  @Input() label1: string = '';
  @Input() label2: string = '';
  @Input() faIcon: string = '';
  @Input() currentChant!: any;
  @Input() currentchantMediaAudioMergeList: any[]=[];
  @Input() currentChantDeperanceList: any[]=[];

  constructor(public mediaPlayerService: MediaPlayerService){}

  get checkIsCurrentNotPlaying():boolean{
    if( !this.playOnClick ){
      return this.currentchantMediaAudioMergeList.findIndex((x)=> this.mediaPlayerService.currentAudioFile?.index === x.id)<0;
    }
    // console.log('currentAudioFile', this.mediaPlayerService.currentAudioFile);
    // console.log('currentChant', this.currentChant?.id);
    return this.mediaPlayerService.currentAudioFile && this.mediaPlayerService.currentAudioFile?.index !== this.currentChant?.id;
  }
  get checkIsCurrentNotPlaying2():boolean{
    return this.mediaPlayerService.currentAudioFile && this.mediaPlayerService.currentAudioFile.index!== this.currentChant.id;
  }
  get checkIsNotPlaying():boolean{
    return this.mediaPlayerService.streamState && !this.mediaPlayerService.streamState?.playing;
  }
}
